var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "invoice-info-container" } }, [
    _c("div", [
      _c("p", { staticClass: "dark-blue-text" }, [
        _vm._v(
          _vm._s(_vm.checkoutSharedContent.enterPaymentInfo.invoiceNote) + " "
        ),
        _c("span", { staticClass: "bold" }, [
          _vm._v(_vm._s(_vm.billing.email)),
        ]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mt-1 dark-blue-text mb-1" }, [
        _vm._v(_vm._s(_vm.checkoutSharedContent.enterPaymentInfo.invoiceDue)),
      ]),
      _vm._v(" "),
      _vm.newBillingProcessApproved
        ? _c("p", { staticClass: "mt-1 dark-blue-text mb-1" }, [
            _vm._v(
              _vm._s(
                _vm.checkoutSharedContent.enterPaymentInfo
                  .newBillingProcessApproved
              )
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }